import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import Swal from 'sweetalert2';
import { ConnectionStatusEnum, NetworkConnection } from '../app/services/shared/network-connection';
import { environment } from '../environments/environment';
import { LogPublishersService } from './services/shared/log-publishers.service';
import { LogService } from './services/shared/log.service';
import { NGaugeService } from './services/shared/ngauge.service';
import { VersionCheckService } from './shared/version-check.service';
import { LOG_LEVELS } from './util/constants';
import { AuthService } from './services/shared/auth.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})

export class AppComponent implements OnDestroy {

  status = 'ONLINE';
  isConnected = true;
  intervalId: any;
  swalOpened = false;

  constructor(
    private http: HttpClient,
    private nguageService: NGaugeService,
    private authService: AuthService,
    private versionCheckService: VersionCheckService,
    private logService: LogService) {
    this.initializeLogConfiguration();
    this.versionCheckService.initVersionCheck(environment.versionUrl);
    this.checkForInternetConnection();
  }

  ngOnInit(): void {
    // check session -> localstorage
    const sessionData = localStorage.getItem('SECURE_SESSION');
    if (sessionData) {
      const user = JSON.parse(sessionData);
      this.authService.regenerateSession(user);
    }
  }

  initializeLogConfiguration() {
    const logConfig = new LogPublishersService(this.http, this.logService, this.nguageService);
    logConfig.buildPublishers();
  }

  checkForInternetConnection() {
    this.intervalId = setInterval(() => {
      if (NetworkConnection.status === ConnectionStatusEnum.Offline && this.swalOpened === false) {
        this.swalOpened = true;
        this.logService.logUserActivity(LOG_LEVELS.INFO, 'Network Connection', 'Lost');
        Swal({
          title: '<strong>Network connection lost</strong>',
          text: '',
          type: 'warning',
          showConfirmButton: false,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.swalOpened = false;
          }
        });
      }
      if (NetworkConnection.status === ConnectionStatusEnum.Online && this.swalOpened === true) {
        this.swalOpened = false;
        Swal({
          title: '<strong>Network connected</strong>',
          text: '',
          type: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonColor: '#3085d6'
        }).then(() => {
          this.swalOpened = false;
          this.logService.logUserActivity(LOG_LEVELS.INFO, 'Network Connection', 'OK');
        });
      }
    }, 3000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    this.status = null;
    this.isConnected = null;
    this.intervalId = null;
    this.swalOpened = null;
    this.versionCheckService = null;
    this.logService = null;
    this.http = null;
    this.nguageService = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts